import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import { Pencil } from "mdi-material-ui";
import React from "react";

import VenueServersForm, { VenueServersFormFragment } from "./Form";

EditDialog.useButtonProps = () => {
  const isAdmin = useIsAdmin();
  return {
    content: "Edit Settings",
    icon: <Pencil />,
    hidden: !isAdmin,
  };
};

export default function EditDialog({ venueServerIds, onClose, onSubmit }) {
  const [data, dataMeta] = useData(
    gql`
      query VeneuServerEditDialogQuery($ids: [ID!]!) {
        venueServers(ids: $ids) {
          id
          ...VenueServersFormFragment
        }
      }
      ${VenueServersFormFragment}
    `,
    { ids: venueServerIds },
  );
  const venueServersUpdate = useActionFragment("venueServersUpdate");

  return (
    <FormDialog
      header="Edit Venue Server Settings"
      onClose={onClose}
      onSubmit={async (formData) => {
        await venueServersUpdate({
          input: {
            venueServerIds,
            ...formData,
          },
        });
        await onSubmit?.();
      }}
      loading={dataMeta.loading}
    >
      <VenueServersForm venueServers={data?.venueServers} />
    </FormDialog>
  );
}
